export enum WebOrderStatus {
    Pending = 0,
    Ok = 2,
}
